import { render, staticRenderFns } from "./RejectOVEModal.vue?vue&type=template&id=368a949e&scoped=true&lang=pug"
import script from "./RejectOVEModal.vue?vue&type=script&lang=js"
export * from "./RejectOVEModal.vue?vue&type=script&lang=js"
import style0 from "./RejectOVEModal.vue?vue&type=style&index=0&id=368a949e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368a949e",
  null
  
)

export default component.exports